(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-language-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('[data-jf-locale-picker][open]').forEach(function(picker){if(!picker.contains(event.target))picker.removeAttribute('open')})});
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('[data-jf-locale-picker][open]').forEach(function(picker){picker.removeAttribute('open');picker.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jifire-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jf-shopping-stories')) {
  customElements.define('jf-shopping-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.storyDialog = this.querySelector('.jf-stories__dialog');
      this.shareDialog = this.querySelector('.jf-stories__share');
      this.stage = this.querySelector('.jf-stories__stage');
      this.templates = [...this.querySelectorAll('template[data-story-content]')];
      this.addEventListener('click', event => {
        const story = event.target.closest('[data-story]');
        if (story) { this.open(this.storyDialog, story); this.show(Number(story.dataset.story)); }
        if (event.target.closest('[data-invite]')) this.open(this.shareDialog, event.target.closest('[data-invite]'));
        if (event.target.closest('[data-close]')) event.target.closest('dialog').close();
        if (event.target.closest('[data-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-next]')) this.show(this.index + 1);
        if (event.target.closest('[data-copy]')) this.copy();
        if (event.target.closest('[data-instagram-share]')) this.shareInstagram();
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => this.cleanup(), options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }, options);
      });
      this.storyDialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index + 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index - 1); }
      }, options);
      this.stage.addEventListener('touchstart', event => {
        const touch = event.changedTouches[0];
        this.start = { x: touch.clientX, y: touch.clientY };
      }, { ...options, passive: true });
      this.stage.addEventListener('touchend', event => {
        if (!this.start) return;
        const touch = event.changedTouches[0];
        const x = touch.clientX - this.start.x, y = touch.clientY - this.start.y;
        this.start = null;
        if (Math.abs(x) > 55 && Math.abs(x) > Math.abs(y) * 1.3) this.show(this.index + (x < 0 ? 1 : -1));
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stage.querySelector('video')?.pause(); }, options);
    }
    async shareInstagram() {
      const link = this.shareDialog?.querySelector('input[readonly]')?.value || location.origin;
      const message = this.dataset.discoverMessage + link;
      try {
        if (navigator.share) {
          await navigator.share({ title: this.dataset.storeName, text: message, url: link });
          return;
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
      try {
        await navigator.clipboard.writeText(message);
        const status = this.shareDialog?.querySelector('[data-status]');
        if (status) status.textContent = this.dataset.instagramCopied;
      } catch (_) {
        const input = this.shareDialog?.querySelector('input[readonly]');
        input?.focus(); input?.select();
        const status = this.shareDialog?.querySelector('[data-status]');
        if (status) status.textContent = this.dataset.instagramCopy;
      }
    }
    open(dialog, trigger) {
      if (!dialog || dialog.open) return;
      this.trigger = trigger;
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      if (this.shareDialog) this.shareDialog.querySelector('[data-status]').textContent = '';
      dialog.showModal();
    }
    stop() {
      const video = this.stage.querySelector('video');
      if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
      this.stage.replaceChildren();
    }
    show(index) {
      if (index < 0 || index >= this.templates.length) return;
      this.stop(); this.index = index;
      this.stage.append(this.templates[index].content.cloneNode(true));
      this.querySelector('[data-counter]').textContent = `${index + 1} / ${this.templates.length}`;
      this.querySelector('[data-prev]').disabled = index === 0;
      this.querySelector('[data-next]').disabled = index === this.templates.length - 1;
      const video = this.stage.querySelector('video');
      if (video) {
        video.addEventListener('error', () => { this.stage.querySelector('.jf-stories__error').hidden = false; }, { once: true });
        video.src = video.dataset.src;
        video.play()?.catch(() => {});
      }
    }
    async copy() {
      const input = this.shareDialog.querySelector('input');
      let copied = false;
      try { await navigator.clipboard.writeText(input.value); copied = true; } catch {
        input.focus(); input.select(); input.setSelectionRange(0, input.value.length);
        try { copied = document.execCommand('copy'); } catch {}
      }
      this.shareDialog.querySelector('[data-status]').textContent = copied ? this.dataset.copySuccess : this.dataset.copyFailed;
    }
    cleanup() {
      this.stop();
      if (this.locked) { document.documentElement.style.overflow = this.oldOverflow; this.locked = false; }
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() { this.cleanup(); this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
